//# sourceMappingURL=llm_capacity.mjs.map
/// <reference types="./llm_capacity.d.mts" />
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";

export function update(store, msg) {
  if (msg instanceof $msg.ApiReturnedRateLimits) {
    let rate_limits = msg.rate_limits;
    let _pipe = $store.set_llm_rate_limits(store, rate_limits);
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedOrganizationsActivity) {
    let months = msg.months;
    let activity = msg.activity;
    let _pipe = $dict.insert(store.organizations_activity, months, activity);
    let _pipe$1 = ((_capture) => {
      return $store.set_organizations_activity(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedLlmUsage) {
    let environment = msg.environment;
    let days = msg.days;
    let usage = msg.usage;
    let _pipe = $dict.insert(store.llm_usage, [environment, days], usage);
    let _pipe$1 = ((_capture) => {
      return $store.set_llm_usage(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else {
    let environment = msg.environment;
    let days = msg.days;
    let usage = msg.usage;
    let _pipe = $dict.insert(store.llm_usage_by_org, [environment, days], usage);
    let _pipe$1 = ((_capture) => {
      return $store.set_llm_usage_by_org(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  }
}
